import { axios } from './axios';
import Context from 'managers/Context';

let INNER_VALUE_CACHE = {};

function normalizeEntityValues(data) {
    return Object.fromEntries(
        Object.entries(data || {})
            .map(([key, item]) => {
                if (!item) return null;

                const id = item.id ?? item.Id ?? key;
                const description = item.description ?? item.MatchingInfo ?? item.label;

                return [
                    id,
                    {
                        ...item,
                        id,
                        description,
                    },
                ];
            })
            .filter(Boolean),
    );
}

export function cacheEntityValues(entityName, data) {
    if (!entityName) return {};

    INNER_VALUE_CACHE[entityName] = INNER_VALUE_CACHE[entityName] || {};
    const normalizedValues = normalizeEntityValues(data);

    Object.assign(INNER_VALUE_CACHE[entityName], normalizedValues);

    return normalizedValues;
}

export function getEntityValue(entityName, ids) {
    if (!entityName || !ids) return Promise.reject('Entity and id is needed');
    INNER_VALUE_CACHE[entityName] = INNER_VALUE_CACHE[entityName] || {};
    const uncachedIds = ids.filter((id) => !INNER_VALUE_CACHE[entityName][id]);

    if (uncachedIds.length === 0) {
        const cachedResults = Object.fromEntries(
            ids.map((id) => [id, INNER_VALUE_CACHE[entityName][id]]),
        );
        return Promise.resolve({ data: cachedResults });
    }

    const lang = Context.config?.userData?.langISOInterface;
    const params = new URLSearchParams();
    params.append('ids[]', uncachedIds.join(','));
    if (lang) params.append('lang', lang);

    return axios
        .get(`/search/v1/fuzzySearch/${entityName}/values?${params.toString()}`)
        .then((result) => {
            cacheEntityValues(entityName, result.data);

            return {
                data: Object.fromEntries(ids.map((id) => [id, INNER_VALUE_CACHE[entityName][id]])),
            };
        });
}
